import { useState, useEffect, useRef } from "react";
import { Divider, Group, TextInput, Button, Paper, Text, Stack, Box, Space } from "@mantine/core";
import { Card, message, Flex, Spin, Alert } from "antd";
import { useAuthContext } from "../../Hooks/UseAuthContext";
import { useReactToPrint } from "react-to-print";









const Merchantcriminalundertaking = ({ rectification = false, stepData, submissionDetails, onSuccess }) => {
    const { user } = useAuthContext();
    const [submitloading, setSubmitloading] = useState(false);
    const [companyProfile, setCompanyProfile] = useState(null);
    const [compliancedetails, setCompliancedetails] = useState(null);
    const [banksdetails, setbanksdetails] = useState(null);
    const [merchantduedeligencedetails, setmerchantduedeligencedetails] = useState(null);
    const [boardresolution, setboardresolution] = useState(null);
    const [undertakingDate, setUndertakingDate] = useState("");
    const componentRef = useRef(null);

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
    });


    const getUserData = async () => { // for get the updated user data after company profile submission
        await fetch('https://api.boompay.in/get-user', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`,
            }
        });
        // const data = await response.json();
        // if (response.status === 200) {
        //     // console.log(data.user);
        //     setUserprofile(data.user);
        //     setActive(data.user.Completed_step);
        //     setLoading(false);
        // } else if (response.status === 401) {
        //     setLoading(false);
        //     console.log('Unauthorized access. Please log in again.');
        //     message.error('Unauthorized access. Please log in again.');
        // } else if (response.status === 404) {
        //     setLoading(false);
        //     console.log('User not found.');
        //     message.error('User not found.');
        // } else {
        //     setLoading(false);
        //     console.log('An error occurred while fetching user data.');
        //     message.error('An error occurred while fetching user data.');
        // }
    }
    const handelSubmit = async () => {
        if (!undertakingDate) {
            message.error('Please enter the under taking date before submitting the form.');
            return;
        }
        const merchantCriminalUndertakingContent = `
<div style="font-family: Times New Roman; line-height: 32px; color: #000;">

    <p>
        <strong>${companyProfile?.Company_name}</strong>
    </p>

    <p>
        ${companyProfile?.Company_address}
    </p>

    <p>
        <strong>Date:-</strong> ${undertakingDate}
    </p>

    <br/>

    <p>
        Dear Sir/Madam,
    </p>

    <p style="text-align:justify;">
        I,
        <strong>
            ${companyProfile?.Directors?.find(
            d => d.Is_Authroized_signatory
        )?.Director_name || ""
            }
        </strong>,
        hereby declare that, as of the date of this letter,
        <strong>${companyProfile?.Company_name}</strong>,
        has not been blacklisted by any government department,
        public sector undertaking (PSU), public sector bank (PSB),
        or any financial institution, nor have we been involved
        in any fraudulent activities since the organization's incorporation.
    </p>

    <p style="text-align:justify;">
        I,
        <strong>
            ${companyProfile?.Directors?.find(
                d => d.Is_Authroized_signatory
            )?.Director_name || ""
            }
        </strong>,
        hereby declare that there are no past criminal cases,
        economic offence cases initiated/pending against the company
        or its Directors/Promoters/Partners/Proprietors by any law
        enforcing agencies.
    </p>

    <br/><br/>

    <p>
        <strong>Name of the Company:</strong>
        ${companyProfile?.Company_name}
    </p>

    <br/><br/><br/>

    <div style="text-align:right;">

        <div
            style="
                width:220px;
                border-bottom:1px solid black;
                margin-left:auto;
                margin-bottom:5px;
            "
        ></div>

        <p style="margin:0;">
            <strong>
                ${companyProfile?.Directors?.find(
                d => d.Is_Authroized_signatory
            )?.Director_name || ""
            }
            </strong>
        </p>

        <p style="margin:0;">
            Authorized Signatory
        </p>

    </div>

</div>
`;

        setSubmitloading(true);
        try {
            const response = await fetch('https://api.boompay.in/submit-merchant-criminal-undertaking', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    Registered_Name_of_Company: companyProfile?.Company_name || "",
                    Registered_Office_Address: companyProfile?.Company_address || "",
                    undertakingDate: undertakingDate,
                    //Directors_of_Company: companyProfile?.Directors || [],
                    Authorised_Signatory: companyProfile?.Directors?.filter(d => d.Is_Authroized_signatory).map(d => ({
                        Authorised_name: d.Director_name,
                        Authorised_mobile_number: d.Director_mobile_number,
                        Authorised_email: d.Director_email,
                        Authorised_DIN_number: d.Director_DIN_number,
                        Authorised_Share_perecentage: d.Share_perecentage,
                    })) || [],
                    Resolution_content: merchantCriminalUndertakingContent,
                    Board_of_resolution_schema_id: boardresolution?._id,
                    Bank_details_schema_id: banksdetails?._id,
                    Merchant_due_deligence_schema_id: merchantduedeligencedetails?._id,
                    Company_profile_schema_id: companyProfile._id,
                    Compliance_and_MAF_schema_id: compliancedetails._id,
                    Completed_step: 7, // Update the Completed_step to 7 after submitting merchant criminal undertaking
                }),
            });
            const data = await response.json();
            if (response.status === 201) {
                //console.log(data.message);
                getUserData();
                setSubmitloading(false);
                message.success(data.message);
            } else if (response.status === 401) {
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
                setSubmitloading(false);
            } else {
                console.log('An error occurred while submitting bank details.');
                message.error('An error occurred while submitting bank details.');
                setSubmitloading(false);
            }
        } catch (error) {
            console.error('Error:', error);
            message.error('An unexpected error occurred. Please try again later.');
            setSubmitloading(false);
        }
    }

    const handleRectificationSubmit = async () => {
        if (!undertakingDate) {
            message.error('Please enter the under taking date before submitting the form.');
            return;
        }
        const merchantCriminalUndertakingContent = `
<div style="font-family: Times New Roman; line-height: 32px; color: #000;">

    <p>
        <strong>${companyProfile?.Company_name}</strong>
    </p>

    <p>
        ${companyProfile?.Company_address}
    </p>

    <p>
        <strong>Date:-</strong> ${undertakingDate}
    </p>

    <br/>

    <p>
        Dear Sir/Madam,
    </p>

    <p style="text-align:justify;">
        I,
        <strong>
            ${companyProfile?.Directors?.find(
            d => d.Is_Authroized_signatory
        )?.Director_name || ""
            }
        </strong>,
        hereby declare that, as of the date of this letter,
        <strong>${companyProfile?.Company_name}</strong>,
        has not been blacklisted by any government department,
        public sector undertaking (PSU), public sector bank (PSB),
        or any financial institution, nor have we been involved
        in any fraudulent activities since the organization's incorporation.
    </p>

    <p style="text-align:justify;">
        I,
        <strong>
            ${companyProfile?.Directors?.find(
                d => d.Is_Authroized_signatory
            )?.Director_name || ""
            }
        </strong>,
        hereby declare that there are no past criminal cases,
        economic offence cases initiated/pending against the company
        or its Directors/Promoters/Partners/Proprietors by any law
        enforcing agencies.
    </p>

    <br/><br/>

    <p>
        <strong>Name of the Company:</strong>
        ${companyProfile?.Company_name}
    </p>

    <br/><br/><br/>

    <div style="text-align:right;">

        <div
            style="
                width:220px;
                border-bottom:1px solid black;
                margin-left:auto;
                margin-bottom:5px;
            "
        ></div>

        <p style="margin:0;">
            <strong>
                ${companyProfile?.Directors?.find(
                d => d.Is_Authroized_signatory
            )?.Director_name || ""
            }
            </strong>
        </p>

        <p style="margin:0;">
            Authorized Signatory
        </p>

    </div>

</div>
`;
        setSubmitloading(true);
        try {
            const response = await fetch('https://api.boompay.in/put/rectify/merchant-criminal-undertaking', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    Registered_Name_of_Company: companyProfile?.Company_name || "",
                    Registered_Office_Address: companyProfile?.Company_address || "",
                    undertakingDate: undertakingDate,
                    //Directors_of_Company: companyProfile?.Directors || [],
                    Authorised_Signatory: companyProfile?.Directors?.filter(d => d.Is_Authroized_signatory).map(d => ({
                        Authorised_name: d.Director_name,
                        Authorised_mobile_number: d.Director_mobile_number,
                        Authorised_email: d.Director_email,
                        Authorised_DIN_number: d.Director_DIN_number,
                        Authorised_Share_perecentage: d.Share_perecentage,
                    })) || [],
                    Resolution_content: merchantCriminalUndertakingContent,
                    Company_profile_schema_id: submissionDetails?.Company_profile_schema_id
                })
            });
            const data = await response.json();
            if (response.status === 201) {
                //console.log(data.message);
                message.success(data?.message)
                onSuccess(); // Refresh user data to update.
                setSubmitloading(false);
            } else if (response.status === 400) {
                message.error(data.message);
                console.log(data.message);
            } else if (response.status === 401) {
                message.error('Unauthorized access. Please log in again.');
                console.log('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                message.error('User not found.');
                console.log('User not found.');
            } else {
                message.error('An error occurred while submitting company profile.');
                console.log('An error occurred while submitting company profile.');
            }
        } catch (error) {
            message.error('An error occurred while submitting company profile.');
            console.error('Error:', error);
        }
        setSubmitloading(false);
    }

    useEffect(() => {
        const getCompanyProfile = async () => {
            const response = await fetch('https://api.boompay.in/get-company-profile', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                //console.log(data.Companyprofile);
                setCompanyProfile(data.Companyprofile);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Company profile not found.');
                message.error('Company profile not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getComplianceandmaf = async () => {
            const response = await fetch('https://api.boompay.in/get-compliance-details-and-maf', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Complianceandmafdetails);
                setCompliancedetails(data.Complianceandmafdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Compliance details not found.');
                message.error('Compliance details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getbanksdetails = async () => {
            const response = await fetch('https://api.boompay.in/get-bank-details', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setbanksdetails(data.Banksdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Banks details not found.');
                message.error('Banks details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getmerchantduedeligence = async () => {
            const response = await fetch('https://api.boompay.in/get-merchant-due-deligence', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setmerchantduedeligencedetails(data.Merchantduedeligence);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Merchant details not found.');
                message.error('Merchant details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getboardofresolution = async () => {
            const response = await fetch('https://api.boompay.in/get-board-of-resolution', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setboardresolution(data.Boardresolution);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Merchant details not found.');
                message.error('Merchant details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }

        if (user) {
            getCompanyProfile();
            getComplianceandmaf();
            getbanksdetails();
            getmerchantduedeligence();
            getboardofresolution();
        }
    }, [user])

    useEffect(() => {
        const getUserData = async () => {
            setSubmitloading(true);
            const response = await fetch('https://api.boompay.in/get-submitted-details-for-rectification', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
           // console.log(data);

            if (response.status === 200) {
                const profile = data.RectificationDetails.Merchant_criminal_undertaking_schema_id;
                // Bank Details
                setUndertakingDate(profile.undertakingDate || '');
                setSubmitloading(false);
            } else if (response.status === 401) {
                setSubmitloading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                setSubmitloading(false);
                console.log('User not found.');
                message.error('User not found.');
            } else {
                setSubmitloading(false);
                console.log('An error occurred while fetching user data.');
                message.error('An error occurred while fetching user data.');
            }
        }

        if (user && rectification) {
            getUserData();
        }
    }, [user, rectification])
    return (
        <>
            <Flex gap="medium" vertical>
                <Spin spinning={submitloading} size="large" description="Please wait...">
                    <Card title="Merchant criminal undertaking" style={{ "box-shadow": "rgba(0, 0, 0, 0.24) 0px 3px 8px", }}>
                        <Alert type="warning" title="Please fill in all the required details as instructed. After completing the form, download the document and upload the signed copy on the company letterhead, duly stamped and signed by the  authorized signatory." showIcon />
                        <Group mt={'xs'}>
                            <TextInput label="Company name" value={companyProfile?.Company_name || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company CIN number" value={companyProfile?.Company_CIN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company PAN number" value={companyProfile?.Company_PAN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="GST number" value={companyProfile?.Company_GST_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="MSME number" value={companyProfile?.Company_MSME_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company address" value={companyProfile?.Company_address || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company mobile number" value={companyProfile?.Company_Mobile_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company email id" value={companyProfile?.Company_email || ""} disabled radius="xs" size="md" />
                        </Group>
                        <Divider label="Merchant criminal undertaking" my="sm" variant="dashed" labelPosition="center" />
                        <Paper
                            withBorder
                            shadow="xs"
                            p="xl"
                            radius="md"
                            style={{
                                backgroundColor: "#fff",
                                fontFamily: "Times New Roman",
                                lineHeight: "32px",
                                color: "#000",
                            }}
                            ref={componentRef}
                        >
                            <Stack gap="md">

                                <Text fw={700} tt="uppercase" ta={'center'}>
                                    {companyProfile?.Company_name}
                                </Text>

                                <Text ta={'center'}>
                                    {companyProfile?.Company_address}
                                </Text>

                                <Group justify="flex-end" mt="md">

                                    <Text fw={600}>
                                        Date:-
                                    </Text>

                                    <TextInput
                                        variant="unstyled"
                                        placeholder="Enter Date"
                                        value={undertakingDate}
                                        onChange={(e) => setUndertakingDate(e.target.value)}
                                        styles={{
                                            input: {
                                                borderBottom: "1px solid black",
                                                borderRadius: 0,
                                                minWidth: "180px",
                                                textAlign: "center",
                                            }
                                        }}
                                    />

                                </Group>

                                <Space h="md" />

                                <Text fw={600}>
                                    Dear Sir/Madam,
                                </Text>

                                <Text ta="justify">

                                    I,{" "}

                                    <strong>
                                        {
                                            companyProfile?.Directors?.find(
                                                d => d.Is_Authroized_signatory
                                            )?.Director_name
                                        }
                                    </strong>

                                    , hereby declare that, as of the date of this letter,{" "}

                                    <strong>
                                        {companyProfile?.Company_name}
                                    </strong>

                                    , has not been blacklisted by any government department,
                                    public sector undertaking (PSU), public sector bank (PSB),
                                    or any financial institution, nor have we been involved in
                                    any fraudulent activities since the organization's incorporation.

                                </Text>

                                <Text ta="justify">

                                    I,{" "}

                                    <strong>
                                        {
                                            companyProfile?.Directors?.find(
                                                d => d.Is_Authroized_signatory
                                            )?.Director_name
                                        }
                                    </strong>

                                    , hereby declare that there are no past criminal cases,
                                    economic offence cases initiated/pending against the company
                                    or its Directors/Promoters/Partners/Proprietors by any law
                                    enforcing agencies, and we do hereby declare that what is
                                    stated above is true to the best of our/my information and belief.

                                </Text>

                                <Space h="xl" />

                                <Text>
                                    <strong>Name of the Company:</strong>{" "}
                                    {companyProfile?.Company_name}
                                </Text>

                                <Space h={80} />

                                <Stack align="flex-end" gap={2}>

                                    <Box
                                        style={{
                                            width: "220px",
                                            borderBottom: "1px solid black",
                                        }}
                                    />

                                    <Text fw={600}>
                                        {
                                            companyProfile?.Directors?.find(
                                                d => d.Is_Authroized_signatory
                                            )?.Director_name
                                        }
                                    </Text>

                                    <Text size="sm">
                                        Authorized Signatory
                                    </Text>

                                </Stack>

                            </Stack>
                        </Paper>
                        {/* <Paper
                            withBorder
                            shadow="xs"
                            p="xl"
                            radius="md"
                            style={{
                                backgroundColor: "#fff",
                                fontFamily: "Times New Roman",
                                lineHeight: "32px",
                                color: "#000",
                            }}
                            ref={componentRef}
                        >
                            <Stack gap="md">

                                <Title order={4} ta="center" fw={700} tt="uppercase">
                                    CERTIFIED TRUE COPY OF THE RESOLUTION PASSED IN THE MEETING OF
                                    BOARD OF DIRECTORS OF THE
                                </Title>

                                <Text ta="center" fw={700} tt="uppercase">
                                    {companyProfile?.Company_name}
                                </Text>

                                <Group gap={5} align="end" wrap="wrap">
                                    <Text fw={600}>
                                        HELD ON
                                    </Text>

                                    <TextInput
                                        variant="unstyled"
                                        placeholder="Enter Meeting Date"
                                        value={boardMeetingDate}
                                        onChange={(e) => setBoardMeetingDate(e.target.value)}
                                        styles={{
                                            input: {
                                                borderBottom: "1px solid black",
                                                borderRadius: 0,
                                                minWidth: "200px",
                                                paddingBottom: "2px",
                                                textAlign: 'center'
                                            }
                                        }}
                                    />

                                    <Text fw={600}>
                                        AT THE REGISTERED OFFICE -
                                    </Text>

                                    <Text span fw={600}>
                                        {companyProfile?.Company_address}
                                    </Text>
                                </Group>

                                <Text ta="justify">
                                    <strong>“RESOLVED THAT</strong> the consent of the Board of Directors
                                    be and is hereby accorded to enter into an agreement with
                                    <strong> BOOM PAY TECHNOLOGY Private Limited </strong>
                                    for availing Payment / Payout and any other ancillary services
                                    on such terms and conditions as specified in the agreement.
                                </Text>

                                <Text ta="justify">
                                    <strong>RESOLVED FURTHER THAT</strong> Mr./Ms.
                                    <strong>
                                        {" "}
                                        {companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Director_name || ""}
                                    </strong>
                                    , Director / Authorized Signatory of the Company, be and
                                    is hereby authorized, severally, to sign and execute on behalf
                                    of the Company all agreements, undertakings, and any other
                                    necessary documents for availing the said services from
                                    <strong> BOOM PAY TECHNOLOGY Private Limited</strong>, and to do all
                                    such acts, deeds, and things as may be required to give effect
                                    to this resolution.
                                </Text>

                                <Text ta="justify">
                                    <strong>RESOLVED FURTHER THAT</strong> a certified true copy of
                                    this resolution be provided to any concerned authority or
                                    party as may be required.”
                                </Text>

                                <Space h="xl" />

                                <Text fw={700}>
                                    CERTIFIED TRUE COPY
                                </Text>

                                <Space h={40} />

                                <Group justify="space-between" align="flex-start" mt="xl">

                                    {companyProfile?.Directors.map((director, index) => (
                                        <Stack key={index} gap={1} align="center">
                                            <Box
                                                style={{
                                                    width: "180px",
                                                    borderBottom: "1px solid black",
                                                    marginBottom: "5px"
                                                }}
                                            />

                                            <Text fw={600} size="sm">
                                                {director?.Director_name}
                                            </Text>

                                            <Text size="xs">
                                                Director
                                            </Text>
                                        </Stack>
                                    ))}

                                </Group>

                            </Stack>
                        </Paper> */}

                        <Group justify="end">
                            <Button mt={'md'} size="lg" color="teal" variant="light" onClick={handlePrint}>Print Merchant criminal undertaking </Button>
                            {/* <Button mt={'md'} size="lg" color="lime" variant="light" onClick={handelSubmit} loading={submitloading}>Save changes</Button> */}
                            <Button
                                mt={'md'}
                                size="lg"
                                color="lime"
                                variant="light"
                                loading={submitloading}
                                onClick={
                                    rectification
                                        ? handleRectificationSubmit
                                        : handelSubmit
                                }
                            >
                                {
                                    rectification
                                        ? "Submit Rectification"
                                        : "Save Changes"
                                }
                            </Button>
                        </Group>

                    </Card>
                </Spin>
            </Flex>

        </>
    )
}
export default Merchantcriminalundertaking